import BackToJobber from "./BackToJobber";
// import JobberLogo from "./JobberLogo";
import Settings from "./Settings";
import styles from "./TopBar.module.scss";

const TopBar = () => {
  const url = '/home';
  return (
    <div className={styles.container}>
      {/* <JobberLogo url={url} /> */}
      <BackToJobber label={"Home"} url={url} />
      <Settings />
    </div>
  );
};

export default TopBar;
